import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#7540ee",
      d: "M17.875 9.625a2.75 2.75 0 0 0-2.637 1.976l-3.628-.515a.7.7 0 0 1-.425-.233l-3.07-3.587a2.75 2.75 0 1 0-1.927.21v7.047a2.75 2.75 0 1 0 1.375 0v-5.79l2.578 3.009c.326.38.779.628 1.274.7l3.782.539a2.75 2.75 0 1 0 2.678-3.356M5.5 4.812a1.375 1.375 0 1 1 2.75 0 1.375 1.375 0 0 1-2.75 0m2.75 12.375a1.375 1.375 0 1 1-2.75 0 1.375 1.375 0 0 1 2.75 0m9.625-3.437a1.375 1.375 0 1 1 0-2.75 1.375 1.375 0 0 1 0 2.75"
    }, null, -1)
  ]))]))
}
export default { render: render }